import { Draft, produce } from 'immer';

import {
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS,
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_BY_DRAFT_REQUEST,
  CONTRACT_SETUP_BY_DRAFT_SUCCESS,
  CONTRACT_SETUP_FIELD_CREATE,
  CONTRACT_SETUP_FIELD_REMOVE,
  CONTRACT_SETUP_FIELDS_OVER_MAX_DOCUMENT_PAGE_DELETE,
  CONTRACT_SETUP_PARTICIPANT_REMOVE,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';
import FieldType from '@app/store/FieldType';

export type ContractSetupFieldsFieldIdsState = string[];

const initialState: ContractSetupFieldsFieldIdsState = [];

const reducer = produce(
  (draft: Draft<ContractSetupFieldsFieldIdsState>, action: ContractSetupAction) => {
    switch (action.type) {
      case CONTRACT_SETUP_ALL_STATE_CLEAR:
      case CONTRACT_SETUP_BY_DRAFT_REQUEST:
      case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST:
        return initialState;
      case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS: {
        const { participantFields } = action.payload;
        participantFields.forEach((participantField) => {
          if (participantField.fieldType === FieldType.CHECKBOX_GROUP) {
            participantField.children.forEach((child) => {
              draft.push(child.fieldId);
            });
          }
          const { fieldId } = participantField;
          draft.push(fieldId);
        });
        return draft;
      }
      case CONTRACT_SETUP_FIELD_CREATE: {
        const { uuid } = action.payload.meta;
        draft.push(uuid);
        return draft;
      }
      case CONTRACT_SETUP_FIELD_REMOVE: {
        const { uuid } = action.payload;
        if (draft.includes(uuid)) {
          draft.splice(draft.indexOf(uuid), 1);
        }
        return draft;
      }
      case CONTRACT_SETUP_PARTICIPANT_REMOVE: {
        const { participantFieldIds } = action.payload;
        return draft.filter((v) => !participantFieldIds.includes(v));
      }
      case CONTRACT_SETUP_FIELDS_OVER_MAX_DOCUMENT_PAGE_DELETE: {
        const { fieldIds } = action.payload;
        return draft.filter((v) => !fieldIds.includes(v));
      }
      case CONTRACT_SETUP_BY_DRAFT_SUCCESS: {
        const { participants } = action.payload;
        participants.forEach((participant) => {
          participant.fields.forEach((field) => draft.push(field.id));
        });
        return draft;
      }
      default:
        return draft;
    }
  },
  initialState
);

export default reducer;
